import * as action from '../store/action-types'

function windowDataProp (key, options) {
  options = Object.assign({}, options)
  return {
    get: function () {
      const value = this.$store.getters.windowData(this.windowId)[key] || options.default
      return (value !== null || value !== undefined) ? value : options.default
    },
    set: function (val) {
      this.$store.dispatch(action.WINDOW_DATA, {
        windowId: this.windowId,
        data: {[key]: val}
      })
    }
  }
}

export default windowDataProp



// WEBPACK FOOTER //
// ./src/utils/windowDataProp.js